export const deepLinkConst = {
  Wallet: {
    parent: 'WalletStack',
    child: 'WalletAdd',
  },
  Refer: 'Refer',

  portfolio: 'Portfolio',
  Contest: 'Contest',
  profile: {
    parent: 'Profile',
  },
  passbook: {
    parent: 'WalletStack',
    child: 'Transaction',
  },
  'wallet/transactions': {
    parent: 'WalletStack',
    child: 'Transaction',
  },
  'wallet/funds': {
    parent: 'WalletStack',
    child: 'WalletAdd',
  },
  club: {
    parent: 'ClubStack',
  },

  //howtotrade: 'LiveDetailsDeepLink',
};

export const deeplinkTabs = [
  'Home',
  'portfolio',
  'WalletTab',
  'Account',
  'learn',
  'Contest',
];
